import { useQuery } from '@tanstack/react-query';

import { validateInviteToAccount } from '@/api/v4/invite-to-account.api';
import { QueryKey } from '@/config/query-client';

export const useValidateInviteToAccountLink = (accountId: string) => {
  return useQuery({
    queryKey: [QueryKey.InviteToAccountLink, 'validate', accountId],
    queryFn: () => validateInviteToAccount({ accountId }),
    enabled: !!accountId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
};
